define('areas/organizationmanager/commands/downloadorgpdfcommand',["require", "exports", "models/account", "services/trace", "services/settings"], function (require, exports, Account, Trace, Configuration) {
    "use strict";
    var DownloadOrgPdfCommand = (function () {
        function DownloadOrgPdfCommand() {
        }
        DownloadOrgPdfCommand.prototype.execute = function (organization) {
            try {
                var path = "download/logindocument/zugangsdaten.pdf";
                var query = "?organizationId=" + organization.id + "&sessionId=" + Account.Principal.current.sessionId;
                var service = Configuration.Settings.getServiceFor("portalstorage", path, query);
                window.open(service, "_blank");
            }
            catch (exception) {
                Trace.traceError(exception, null, "organizationmanager:networkmember", true);
            }
        };
        return DownloadOrgPdfCommand;
    }());
    return DownloadOrgPdfCommand;
});

